

type Props = {
  onChange: (lang: 'en' | 'th') => void
  currentLang: 'en' | 'th'
}

export default function LanguagePicker({ onChange, currentLang }: Props) {
  return (
    <div style={{ display: 'flex', gap: '0.5rem' }}>
      {(['en', 'th'] as const).map((lang) => (
        <button
          key={lang}
          onClick={() => onChange(lang)}
          style={{
            padding: '0.25rem 0.5rem',
            background: currentLang === lang ? '#FF4500' : 'transparent',
            color: '#FFD700',
            border: '1px solidrgb(255, 255, 255)',
            cursor: 'pointer',
            fontFamily: 'Press Start 2P, monospace',
            fontSize: '0.75rem',
            fontWeight: '600',
          }}
        >
          {lang.toUpperCase()}
        </button>
      ))}
    </div>
  )
}
